import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { ApiProject } from "@/api/api.types";
import { createCrossPlatformStorage } from "./storage.adapter";

interface ProjectsState {
  list: ApiProject[];
  currentProject: ApiProject | null;
  _hasHydrated: boolean;
  setProjects: (projects: ApiProject[]) => void;
  setCurrentProject: (project: ApiProject | null) => void;
  // Computed getter - get current project
  getCurrentProject: () => ApiProject | null;
}

// Type for persisted state (only what we persist)
type PersistedProjectsState = Pick<ProjectsState, "currentProject">;

export const useProjectsStore = create<ProjectsState>()(
  persist(
    immer((set, get) => ({
      list: [],
      currentProject: null,
      _hasHydrated: false,
      setProjects: (projects) =>
        set((state) => {
          state.list = projects;
        }),
      setCurrentProject: (project) =>
        set((state) => {
          state.currentProject = project;
        }),
      getCurrentProject: () => {
        const state = get();
        return state.currentProject;
      },
    })),
    {
      name: "projects-storage",
      storage: createJSONStorage(() => createCrossPlatformStorage()),
      // Persist currentProject (full object), not the list
      partialize: (state): PersistedProjectsState => ({
        currentProject: state.currentProject,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state._hasHydrated = true;
        }
      },
    },
  ),
);
